import { findOrdersCountAndNetInvoiceSumByAdm } from "@/graphql/schemas/revenue/utils/findOrdersCountAndNetInvoiceSumByAdm"
import { checkPermissions } from "@/graphql/schemas/shared/permissions/permissions"
import { DomainObjects, Operations } from "@/graphql/schemas/shared/permissions/permissionsConfig"

export const queryOrdersCountAndNetInvoiceSumByAdm = {
  async ordersCountAndNetInvoiceSumByAdm(parent, args, context) {
    const { admNumber, year } = args

    const user = context?.user

    await checkPermissions({
      user,
      admNumber,
      domainObject: DomainObjects.REVENUES,
      operation: Operations.READ,
    })

    const { openOrders } = await findOrdersCountAndNetInvoiceSumByAdm({
      admNumber,
      year,
    })

    return openOrders
  },
}
